<!-- Menu to select sort criteria for document order-->
<!-- 3 modes enabled: -->
<!-- alphabetic: ascending alphabetic order -->
<!-- byImportance: unread mandatoryToRead items, unread/not acknowledged items, unread items, read mandatoryToRead items, read items -->
<!-- byDateUpdatedDesc: latest items first-->

<!-- The component has a v-model attribute that represents the name of the sorter (name is one of the above) -->
<!-- Properties: iconClass - the css class name(s) which will be set on the icon button -->
<template>
  <v-menu offset-y close-on-content-click>
    <template v-slot:activator="{ on, attrs }">
      <v-btn :class="iconClass" :color="color" icon :small="smallIcon" v-bind="attrs" v-on="on">
        <v-icon :small="smallIcon">mdi-sort</v-icon>
      </v-btn>
    </template>
    <v-list class="py-0">
      <v-list-item-group v-model="sorterName" color="primary">
        <template v-for="(item, i) in items">
          <v-list-item :key="i" :value="item.value">
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="i < items.length - 1" :key="`${i}-divider`"></v-divider>
        </template>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
const SORT_BY_ALPHABETIC = 'alphabetic';
import { SORT_FUNCTION } from '@/common/constants';
export default {
  name: 'SortMenu',
  props: {
    value: {
      type: String,
      default: SORT_FUNCTION.BY_IMPORTANCE,
    },
    color: { type: String, default: null },
    iconClass: { type: String, default: 'sort-menu' },
    displayCockpitSorters: { type: Boolean, default: false },
    smallIcon: { type: Boolean, default: true },
  },
  data() {
    return {
      sorterName: this.value,
      items: [
        ...(this.displayCockpitSorters ? [{ text: this.$t('sort.order'), value: SORT_FUNCTION.BY_SORT_FIELD }] : []),
        ...(this.displayCockpitSorters ? [{ text: this.$t('sort.orderDesc'), value: SORT_FUNCTION.BY_SORT_FIELD_DESC }] : []),
        { text: this.$t('sort.alpha'), value: SORT_BY_ALPHABETIC },
        { text: this.$t('sort.alphaDesc'), value: SORT_FUNCTION.BY_ALPHABETIC_DESC },
        { text: this.$t('sort.importance'), value: SORT_FUNCTION.BY_IMPORTANCE },
        { text: this.$t('sort.byDateUpdatedDesc'), value: SORT_FUNCTION.BY_DATE_UPDATED_DESC },
      ],
    };
  },
  watch: {
    sorterName(newValue) {
      this.$emit('input', newValue);
    },
    value(newValue) {
      this.sorterName = newValue;
    },
  },
};
</script>
<style scoped>
.sort-menu {
  height: 30px;
  width: 30px;
  z-index: 10000;
}
</style>
